/**
 * Pure helper for delete-cascade.ts, kept apart from it so it is unit-testable without a database or config
 * (tests/server/collect-strings.test.ts).
 */

// File ids are ObjectId hex strings (or the client's shorter hex variant). Long strings — answers, chat messages —
// can never be one, and leaving them out keeps the `$in` query small.
const ID_LIKE = /^[\w-]{1,64}$/;

/** Every id-like string anywhere in `value` — nested objects and arrays included, keys excluded. */
export function collectStrings(value: unknown, into = new Set<string>()): Set<string> {
  if (typeof value === 'string') {
    if (ID_LIKE.test(value)) into.add(value);
  } else if (Array.isArray(value)) {
    for (const item of value) collectStrings(item, into);
  } else if (value !== null && typeof value === 'object') {
    const proto = Object.getPrototypeOf(value);
    // Plain documents only: an ObjectId or Date carries no file id, and its internals are not worth walking.
    if (proto === Object.prototype || proto === null) {
      for (const item of Object.values(value)) collectStrings(item, into);
    }
  }
  return into;
}
